import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { dateFormated } from "../../functionalComponents/dataFormatFunctions";
import FlagIcon from "@material-ui/icons/Flag";
const useStyles = makeStyles({
  table: {
    width: "100%",
    // minWidth: 650,
    "& .MuiTableCell-root": {
      // padding: "8px 12px",
      lineHeight: "1.2",
      // fontSize: "0.8rem",
      //   verticalAlign: "top",
      //   fontSize: "12px",
    },
    // "& .MuiTableRow-root": {
    //   height: "auto",
    // },
  },
  headerCell: {
    fontWeight: 500,
    // fontSize: "0.8rem",
  },
  grayRow: {
    backgroundColor: "#f7f6f6", // Lighter gray for even rows
  },
  spaceBetween: {
    lineHeight: "2",
  },
  lotNumbers: {
    display: "block", // Use block to ensure vertical stacking of lot numbers
    lineHeight: "1.5",
  },
  stickyHeaderRow: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  tableContainer: {
    maxHeight: "500px", // Set a fixed height for the table container
    overflow: "auto", // Enable
    width: "100%",
  },
});

export default function ViewRmPmLotTable({
  apiData,
  loading,
  error,
  batchDetails,
}) {
  const classes = useStyles();

  // const transformedData = apiData?.map((item) => ({
  //   sponsorCode: `${item.sponsorMaterialCode ?? "NA"} / ${
  //     item.sponsorMaterialName ?? "NA"
  //   }`,
  //   cmoCode: `${item.cmoMaterialCode ?? "NA"} / ${
  //     item.cmoMaterialName ?? "NA"
  //   }`,
  //   bomQuantity: item.componentQuantity ?? "NA",
  //   uom: item.uom ?? "NA",
  //   netAvailableQty: item.netQuantityAvailable ?? "NA",
  //   lotNumbers: item.LotNumberList?.map((lot) => lot.lotNumber ?? "NA") ?? [
  //     "NA",
  //   ],
  //   plannedAllocation: item.LotNumberList?.map(
  //     (lot) => lot.plannedAllocatedQuantity ?? "NA"
  //   ) ?? ["NA"],
  //   actualAllocation: item.LotNumberList?.map(
  //     (lot) => lot.actualAllocatedQuantity ?? "NA"
  //   ) ?? ["NA"], // Placeholder, update if actual data is provided
  //   quantityVariance: 0, // Placeholder for calculation logic
  //   lotsMismatch: "NO", // Placeholder, needs validation logic
  // }));

  const displayLoading = (
    <TableRow>
      <TableCell colSpan={10} align="center">
        <CircularProgress color="primary" thickness={7} />
      </TableCell>
    </TableRow>
  );

  const tableError = (
    <TableRow
      style={{
        border: "2px solid #FF0000",
        backgroundColor: "#FFF0F0",
        marginTop: "10px",
      }}
    >
      <TableCell colSpan={10} align="center">
        Something went wrong. Please try again later.
      </TableCell>
    </TableRow>
  );

  const noRecordsFoundMsgDisplay = (
    <TableRow>
      <TableCell colSpan={10} align="center">
        No records found
      </TableCell>
    </TableRow>
  );

  const mergeConsumptionWithPlanned = (
    allocationDetails,
    consumptionDetails
  ) => {
    // Create a map for quick lookup of consumed quantities by batch number
    const consumptionMap = new Map();

    consumptionDetails.forEach(
      ({
        BomComponentConsumedQuantity,
        componentBatchNumber,
        expiryDate,
        netAvailableQuantity,
        batchNearExpiry,
      }) => {
        consumptionMap.set(componentBatchNumber, {
          BomComponentConsumedQuantity,
          expiryDate,
          netAvailableQuantity,
          batchNearExpiry,
        });
      }
    );

    // Merge planned allocation details with actual consumption
    let mergedDetails = allocationDetails.map(
      ({
        plannedAllocatedQuantity,
        lotNumber,
        plannedLotAllocation,
        netAvailableQuantity,
        expiryDate,
      }) => {
        const consumptionData = consumptionMap.get(lotNumber) || {};
        return {
          plannedAllocatedQuantity,
          lotNumber,
          plannedLotAllocation,
          netAvailableQuantity,
          expiryDate,
          BomComponentConsumedQuantity: consumptionData.BomComponentConsumedQuantity || null,
          batchNearExpiry: consumptionData.batchNearExpiry || false,
        };
      }
    );

    // Add any consumed batches that were not in planned allocation
    consumptionDetails.forEach(
      ({
        BomComponentConsumedQuantity,
        componentBatchNumber,
        expiryDate,
        netAvailableQuantity,
        batchNearExpiry,
      }) => {
        if (
          !allocationDetails.some(
            ({ lotNumber }) => lotNumber === componentBatchNumber
          )
        ) {
          mergedDetails.push({
            plannedAllocatedQuantity: null,
            lotNumber: componentBatchNumber,
            plannedLotAllocation: null,
            netAvailableQuantity: netAvailableQuantity,
            expiryDate: expiryDate,
            BomComponentConsumedQuantity,
            batchNearExpiry: batchNearExpiry || false,
          });
        }
      }
    );

    return mergedDetails;
  };

  return (
    <Box style={{ marginTop: "1em" }}>
      <TableContainer
        component={Paper}
        style={{ margin: "1em 0" }}
        className={classes.tableContainer}
      >
        <Table className={classes.table} stickyHeader>
          <TableHead>
            <TableRow
              className={`${classes.grayRow} ${classes.stickyHeaderRow}`}
            >
              <TableCell className={classes.headerCell} align="left">
                BMS Material Code / Description
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Material BoM Qty.
              </TableCell>
              <TableCell className={classes.headerCell} align="left">
                UoM
              </TableCell>

              <TableCell className={classes.headerCell} align="left">
                BMS Material Batch Numbers
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Net Available Qty.
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Expiry Date
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Planned Allocated Qty.
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Actual Allocated Qty.
              </TableCell>
              <TableCell className={classes.headerCell} align="right">
                Quantity Variance (%)
              </TableCell>
              <TableCell className={classes.headerCell} align="center">
                Batches Mismatch
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? displayLoading
              : error
              ? tableError
              : apiData?.length === 0
              ? noRecordsFoundMsgDisplay
              : apiData?.map((row, index) => {
                  let allocation = mergeConsumptionWithPlanned(
                    row?.plannedLotNumberAllocationDetails || [],
                    row?.actualConsumptionDetails || []
                  );
                
                  return (
                    <React.Fragment key={index}>
                      <TableRow
                        className={index % 2 === 1 ? classes.grayRow : ""}
                      >
                        <TableCell
                          scope="row"
                   
                          rowSpan={allocation.length > 1 && allocation.length}
                          align="left"
                        >
                          {row?.componentCode && row?.componentName
                            ? `${row.componentCode} / ${row.componentName}`
                            : "NA"}
                        </TableCell>
                        <TableCell
                          scope="row"
                          rowSpan={allocation.length > 1 && allocation.length}
                          align="right"
                        >
                          {/* {row?.BOMQuantity || row?.BOMQuantity == 0
                            ? Number(row?.BOMQuantity).toFixed(3)
                            : "NA"} */}
                          {row?.componentQuantity || row?.componentQuantity == 0
                            ? Number(row?.componentQuantity).toFixed(3)
                            : "NA"}
                        </TableCell>
                        <TableCell
                          scope="row"
                          rowSpan={allocation.length > 1 && allocation.length}
                          align="left"
                        >
                          {row?.uom ? row?.uom : "NA"}
                        </TableCell>

                        <TableCell align="right">
                          {allocation.length > 0
                            ? allocation[0].lotNumber
                              ? (
                                  <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "flex-start",
                                    whiteSpace: "nowrap"
                                  }}>
                                    <span style={{ marginRight: allocation[0]?.batchNearExpiry ? "0px" : "0" }}>
                                      {allocation[0].lotNumber}
                                    </span>
                                    {allocation[0]?.batchNearExpiry && (
                                      <FlagIcon
                                        style={{
                                          color: "yellow",
                                          fontSize: 20,
                                          stroke: "black",
                                          strokeWidth: 1.5,
                                          verticalAlign: "middle"
                                        }}
                                      />
                                    )}
                                  </div>
                                )
                              : "NA"
                            : "NA"}
                        </TableCell>
                        <TableCell align="right">
                          {allocation.length > 0
                            ? allocation[0]?.netAvailableQuantity ||
                              allocation[0]?.netAvailableQuantity == 0
                              ? allocation[0]?.netAvailableQuantity == 0
                                ? 0
                                : Number(
                                    allocation[0]?.netAvailableQuantity
                                  ).toFixed(3)
                              : "NA"
                            : "NA"}
                        </TableCell>

                        <TableCell
                          align="right"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {allocation.length > 0
                            ? allocation[0]?.expiryDate
                              ? dateFormated(
                                  allocation[0]?.expiryDate,
                                  "DD-MMM-YYYY",
                                  "NA"
                                ).toUpperCase()
                              : "NA"
                            : "NA"}
                        </TableCell>

                        <TableCell align="right">
                          {/* {allocation.length > 0
                            ? allocation[0].plannedLotAllocation
                              ? Number(
                                  allocation[0].plannedLotAllocation
                                ).toFixed(3)
                              : 0
                            : 0} */}
                          {allocation.length > 0
                            ? allocation[0].plannedAllocatedQuantity
                              ? Number(
                                  allocation[0].plannedAllocatedQuantity
                                ).toFixed(3)
                              : 0
                            : 0}
                        </TableCell>
                        <TableCell align="right">
                          {allocation.length > 0 &&
                          batchDetails?.bomConsumptionAddedIndicator
                            ? allocation[0].BomComponentConsumedQuantity
                              ? Number(
                                  allocation[0].BomComponentConsumedQuantity
                                ).toFixed(3)
                              : 0
                            : "NA"}
                        </TableCell>

                        <TableCell
                          scope="row"
                          rowSpan={allocation.length > 1 && allocation.length}
                          align="right"
                        >
                          {!batchDetails?.bomConsumptionAddedIndicator ? (
                            <span>NA</span>
                          ) : row?.quantityVarianceValue === "NA" || row?.quantityVarianceValue === null || row?.quantityVarianceValue === undefined ? (
                            <span>NA</span>
                          ) : (row?.quantityVarianceValue ?? row?.quantityVarianceValue === 0) ? (() => {
                            const value = row?.quantityVarianceValue;
                            const isDecimal = value % 1 !== 0;
                            const color = row?.quantityVariancePresent ? "red" : "black";

                            return (
                              <span style={{ color }}>
                                {isDecimal ? Number(value).toFixed(2) : value}
                              </span>
                            );
                          })() : (
                            0
                          )}
                        </TableCell>
                        <TableCell
                          scope="row"
                          rowSpan={allocation.length > 1 && allocation.length}
                          align="center"
                        >
                          {!batchDetails?.bomConsumptionAddedIndicator ? (
                            "NA"
                          ) : row?.lotsMismatch ? (
                            <span style={{ color: "red " }}>Yes</span>
                          ) : (
                            "No"
                          )}
                        </TableCell>
                      </TableRow>
                      {allocation.length > 1 &&
                        allocation.slice(1).map((val, i) => (
                          <TableRow
                            key={i}
                            className={index % 2 === 1 ? classes.grayRow : ""}
                          >
                            {/* <TableCell ></TableCell>
                            <TableCell ></TableCell>
                            <TableCell ></TableCell>
                            <TableCell ></TableCell> */}
                            <TableCell align="right">
                              {val.lotNumber ? (
                                <div style={{ 
                                  display: "flex", 
                                  alignItems: "center", 
                                  justifyContent: "flex-start",
                                  whiteSpace: "nowrap"
                                }}>
                                  <span style={{ marginRight: val?.batchNearExpiry ? "4px" : "0" }}>
                                    {val.lotNumber}
                                  </span>
                                  {val?.batchNearExpiry && (
                                    <FlagIcon
                                      style={{
                                        color: "yellow",
                                        fontSize: 20,
                                        stroke: "black",
                                        strokeWidth: 1.5,
                                        verticalAlign: "middle"
                                      }}
                                    />
                                  )}
                                </div>
                              ) : "NA"}
                            </TableCell>
                            <TableCell
                              //   rowSpan={
                              //     allocation.length > 1 &&
                              //     allocation.length
                              //   }
                              align="right"
                            >
                              {val?.netAvailableQuantity ||
                              val?.netAvailableQuantity == 0
                                ? val?.netAvailableQuantity == 0
                                  ? 0
                                  : Number(val?.netAvailableQuantity).toFixed(3)
                                : "NA"}
                            </TableCell>

                            <TableCell
                              align="right"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {val?.expiryDate
                                ? dateFormated(
                                    val?.expiryDate,
                                    "DD-MMM-YYYY",
                                    "NA"
                                  ).toUpperCase()
                                : "NA"}
                            </TableCell>
                            <TableCell align="right">
                              {/* {val.plannedLotAllocation
                                ? Number(val.plannedLotAllocation).toFixed(3)
                                : 0} */}
                              {val.plannedAllocatedQuantity
                                ? Number(val.plannedAllocatedQuantity).toFixed(3)
                                : 0}
                            </TableCell>
                            <TableCell align="right">
                              {!batchDetails?.bomConsumptionAddedIndicator
                                ? "NA"
                                : val.BomComponentConsumedQuantity ||
                                  val.BomComponentConsumedQuantity == 0
                                ? Number(
                                    val.BomComponentConsumedQuantity
                                  ).toFixed(3)
                                : 0}
                            </TableCell>
                            {/* <TableCell ></TableCell>
                            <TableCell ></TableCell> */}
                          </TableRow>
                        ))}
                    </React.Fragment>
                  );
                })}
          </TableBody>
        </Table>
      </TableContainer>
      
      {/* Legend for Material Near Expiry Flag */}
      {apiData?.some(row => 
        row?.actualConsumptionDetails?.some(item => item?.batchNearExpiry === true)
      ) && (
        <div style={{ 
          marginTop: "1rem", 
          padding: "0.5rem", 
          backgroundColor: "#f9f9f9", 
          border: "1px solid #e0e0e0", 
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          fontSize: "0.875rem"
        }}>
          <Typography variant="caption" style={{ fontSize: "0.875rem", marginRight: "8px" }}>
            Legend:
          </Typography>
          <FlagIcon
            style={{
              color: "yellow",
              fontSize: 20,
              stroke: "black",
              strokeWidth: 1.5,
              marginRight: "8px"
            }}
          />
          <Typography variant="caption" style={{ fontSize: "0.875rem" }}>
            Material near expiry
          </Typography>
        </div>
      )}

    </Box>
  );
}
